var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6538 19.0811L30.5816 13.1041C32.8497 13.8427 35 12.1247 35 9.90058C35 8.0324 33.4876 6.51724 31.6207 6.51724C29.7538 6.51724 28.2414 8.0324 28.2414 9.90058C28.2414 9.94118 28.2518 9.97897 28.2536 10.0191L21.7354 14.9331L18.0827 11.0225C17.3541 10.2218 16.0746 10.1587 15.2795 10.9678L10.9413 15.2739C8.81213 14.9131 7 16.5629 7 18.6006C7 20.4688 8.51239 21.9839 10.3793 21.9839C12.4445 21.9839 14.0884 20.1238 13.6964 17.9832L16.6005 15.0313L20.0647 18.8385C20.7351 19.5753 21.8561 19.6824 22.6538 19.0811ZM14.5766 25.9804C13.0982 25.8199 10.5914 25.8199 9.11299 25.9804C8.46334 26.0512 7.96552 26.6761 7.96552 27.4237V34.0672C7.96552 34.8677 8.53218 35.5172 9.23276 35.5172H14.4569C15.1575 35.5172 15.7241 34.8677 15.7241 34.0672V27.4144C15.7241 26.6666 15.2263 26.0512 14.5766 25.9804ZM24.2318 23.0804C22.7533 22.9199 20.2466 22.9199 18.7682 23.0804C18.1185 23.1512 17.6207 23.7761 17.6207 24.5237V34.0672C17.6207 34.8677 18.1874 35.5172 18.8879 35.5172H24.1121C24.8126 35.5172 25.3793 34.8677 25.3793 34.0672V24.5237C25.3793 23.7761 24.8815 23.1512 24.2318 23.0804ZM33.887 18.2471C32.4085 18.0866 29.9018 18.0866 28.4233 18.2471C27.7737 18.3178 27.2759 18.9428 27.2759 19.6904V34.0672C27.2759 34.8677 27.8425 35.5172 28.5431 35.5172H33.7672C34.4678 35.5172 35.0345 34.8677 35.0345 34.0672V19.6904C35.0345 18.9428 34.5367 18.3178 33.887 18.2471Z",
    fill: "#3E7F91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.38dfdb952e8ddf6b1bacca6d8ebd1346.svg";
export { ForwardRef as ReactComponent };